import './sass/about.scss';
import './sass/experience.scss';
import { motion } from "framer-motion";
import { getSectionAnimation } from '../animations/sections';

import { useState } from 'react';
function Experience() {
  const worked = [
    {
      title: 'Core Contributor',
      company: 'OpenWISP',
      location: 'Remote',
      range: 'Jan 2022 - Present',
      url: 'https://openwisp.org',
      content: [
        `As an OpenWISP core contributor, I've played a key
        role in developing and maintaining critical software
        components that drive OpenWISP, an open-source, hackable
        network management system. I have over 150 merged PRs.`,

        `Collaborating with the OpenWISP community to identify
        user requirements and develop solutions to meet their needs.`,

        `Writing high-quality, efficient, and maintainable code
        using Python, Django, and related technologies.`,

        `Implementing new features and improvements to the OpenWISP core modules.`,

        `Fixing bugs and issues reported by the OpenWISP
        community and conducting thorough testing to ensure software quality.`
      ],
    },
    {
      title: 'Student Developer',
      company: 'Google Summer of Code 23',
      location: 'Remote',
      range: 'May 2023 - Aug 2023',
      url: 'https://aryamanz29.medium.com/add-support-for-automatic-management-of-zerotier-tunnels-791be96903bf',
      content: [
        `Developed support for automatic management of
        ZeroTier Tunnels in OpenWISP, enabling seamless
        integration with ZeroTierfor network connectivity.`,

        `The Implemented ZeroTier Backend automates the setup
        of ZeroTier tunnels on OpenWRT devices, simplifying
        the configuration process for users.`,

        `Designed and implemented a parser in OpenWISP Network Topology
        capable of parsing and processing ZeroTier peers information,
        enhancing network visualization and monitoring capabilities.`
      ],
    },
    {
      title: 'Software Developer Intern',
      company: 'Adbrew',
      location: 'Remote',
      range: 'Oct 2022 - Nov 2022',
      url: 'https://adbrew.io',
      content: [
        `Collaborated closely with Adbrew's engineering team
        to enhance their Amazon PPC automation tool.`,

        `My responsibilities included building new features to assist
        Amazon sellers in making informed business decisions, monitoring and
        resolving production issues, building frontend React components and CI/CD
        pipelines using GitHub Actions.`
      ],
    },
    {
      title: 'Student Developer',
      company: 'Google Summer of Code 22',
      location: 'Remote',
      range: 'Jun 2022 - Sep 2022',
      url: 'https://aryamanz29.medium.com/iperf-check-to-openwisp-monitoring-gsoc22-project-report-2661eddd3f77',
      content: [
        `Developed an Iperf3 check for the OpenWISP Monitoring.`,

        `Developed Iperf3 check is extremely flexible and extensible,
        as it supports almost all network measurement parameters.`,

        `Added support for multiple client servers
        and RSA authentication in the Iperf3 check.`,

        `Contributed to additional improvements to the
        OpenWISP Monitoring system, such as enhancing
        monitoring charts, and monitoring interface.`
      ],
    },
    {
      title: 'Full Stack Developer Intern',
      company: 'Raven Protocol',
      location: 'Remote',
      range: 'Aug 2021 - Nov 2021',
      url: 'https://ravenprotocol.com',
      content: [
        `Developed web AIOHTTP endpoints for
        Ravsock (Raven socket server) and integrated various modules into it.`,

        `Developed and improved multiple REST API endpoints
        for RavML (Raven machine learning library), using Django
        rest framework which reduced the API response time by up to 50%.`,

        `Designed and implemented Raven dashboard from scratch using Django
        and Bootstrap to monitor various workflow of the Raven modules. Migrated
        and improved Ravviz (Raven visualization libary) to visualize newly revamped Ravsock server.`,

        `Enhanced and fixed React re-usable components, worked on DApp,
        added features such as web3 wallet integration and more.`,

        `Containerized multiple Raven web modules and documented their deployment processes.`
      ],
    },
    {
      title: 'Full Stack Developer Intern',
      company: 'IRSC (Solve Foundation)',
      location: 'Remote',
      range: 'Jun 2021 - Aug 2021',
      url: 'https://www.linkedin.com/company/indian-road-safety-campaign',
      content: [
        `Developed the entire backend of the ISAFE (Indian Road Safety Event Management System)
        using the Django Web Framework, JQuery and Bootstrap, and deployed it to AWS.`,

        `Developed backend components including team event submissions,
        team registration, event leaderboard, and an admin-teamchat application.
        Also worked on various optimizations to enhance application performance.`
      ],
    },
  ];
  const [selected, setSelected] = useState(worked[0]);

  return (
  <motion.section id="experience" className="experience" {...getSectionAnimation}>
      <h2 className="numbered-heading">Experiences</h2>
      <div className="inner">
        <div className="tabList">
          {worked.map((item, index) => (
            <button
              className={
                'tabButtons ' + (selected.company === item.company && 'active')
              }
              onClick={() => setSelected(item)}
              role="tab"
              key={index}
            >
              {item.company}
            </button>
          ))}
        </div>
        <div className="tabPanels">
          <div className="tabPanels-inner">
            <h3>
              <span>{selected.title}</span>
              <span className="company">
                &nbsp;@&nbsp;
                <a href={selected.url} className="link">
                  {selected.company}
                </a>
              </span>
            </h3>
            <p className="range">{selected.range}</p>
            <div>
              <ul>
                {selected.content.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
  </motion.section>
  );
}
export default Experience;
